import { render } from "./FullFillBox.vue?vue&type=template&id=e54e24f4&scoped=true"
import script from "./FullFillBox.vue?vue&type=script&lang=js"
export * from "./FullFillBox.vue?vue&type=script&lang=js"

import "./FullFillBox.vue?vue&type=style&index=0&id=e54e24f4&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54e24f4"]])

export default __exports__